import React from 'react';
import Breadcrumb from '../../../../core/layout/Breadcrumb';
import Card from '../../../../core/layout/Card';
import Tabs from '../../../../core/layout/Tabs';
import ContentHistoryDialogContainer from './ContentHistoryDialogContainer';
import ContentCourseTab from './ContentCourseTab';
import ContentMasteryTestTab from './ContentMasteryTestTab';
import KpiReferenceMonth from '../../commons/KpiReferenceMonth';

const ContentScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'KPIs Content',
        },
      ]}
    />
    <Card key="card">
      <KpiReferenceMonth />
    </Card>
    <Tabs
      tabs={[
        {
          title: 'Curso',
          key: 'course',
          content: <ContentCourseTab />,
        },
        {
          title: 'Mastery Test',
          key: 'mastery-test',
          content: <ContentMasteryTestTab />,
        },
      ]}
    />
    <ContentHistoryDialogContainer />
  </div>
);

export default ContentScene;
